import { render, staticRenderFns } from "./render_radio_group.vue?vue&type=template&id=60a3e23c&scoped=true&"
import script from "./render_radio_group.vue?vue&type=script&lang=js&"
export * from "./render_radio_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a3e23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a3e23c')) {
      api.createRecord('60a3e23c', component.options)
    } else {
      api.reload('60a3e23c', component.options)
    }
    module.hot.accept("./render_radio_group.vue?vue&type=template&id=60a3e23c&scoped=true&", function () {
      api.rerender('60a3e23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_radio_group.vue"
export default component.exports